<template>
  <b-card v-bind:id="'hostItem_' + quiz.id">
    <template v-slot:header>
      <div class="d-flex justify-content-between">
        <div class="flex-grow-1" @click="changeName">
          <b-form
            v-if="editingName"
            inline
            @submit.prevent="nameChanged"
            class="w-100"
          >
            <span v-bind:class="statusClass">
              <b-icon-circle-fill />
            </span>
            <b-form-input
              ref="nameInput"
              v-model="newName"
              v-bind:plaintext="!editingName"
              trim
              lazy
              class="ml-2 d-inline w-auto tq-hover-a"
              @blur="nameChanged"
            />
          </b-form>
          <div v-else>
            <span v-bind:class="statusClass">
              <b-icon-circle-fill />
            </span>
            <span
              class="ml-2 tq-hover-a"
              v-bind:id="'hostItem_title_' + quiz.id"
              >{{ quiz.name }}</span
            >
          </div>
        </div>

        <span @click="changeDate" class="tq-hover-a align-self-center">
          {{ quizDate }}
        </span>
      </div>
    </template>

    <div class="container-fluid text-medium">
      <div class="row justify-content-between">
        <div>
          <span class="tq-blue tq-hover-a" @click.prevent="changeStatus"
            >Status: {{ quizStatusString }}</span
          >
        </div>
        <div>
          <TopquizTippy placement="left" noHeader="true">
            <template v-slot:trigger>
              <span class="tq-blue tq-hover-a" @click.prevent="changeVisibility"
                >Visibility: {{ quizVisibilityString }}</span
              >
            </template>
            <p>{{ explainVisibility }}</p>
          </TopquizTippy>
        </div>
      </div>
    </div>

    <template v-slot:footer>
      <div class="d-flex flex-row justify-content-between">
        <HostQuizItemControls v-bind:quiz="quiz" />
        <router-link v-bind:to="'/host/go/' + quiz.id">
          <b-button variant="outline-dark">
            <b-icon-play-fill />
          </b-button>
        </router-link>
      </div>
    </template>
    <DialogQuizDate
      v-model="editingDate"
      v-bind:quiz="quiz"
      @ok="dateChanged"
    />
    <DialogQuizStatus
      v-model="editingStatus"
      v-bind:quiz="quiz"
      @ok="statusChanged"
    />
  </b-card>
</template>

<script>
import HostQuizItemControls from "@/components/HostQuizItemControls";
import TopquizTippy from "@/components/TopquizTippy";
import DialogQuizDate from "@/components/host/DialogQuizDate";
import DialogQuizStatus from "@/components/host/DialogQuizStatus";
import explanations from "@/assets/explanations.js";

export default {
  name: "HostQuizItem",
  props: ["quiz"],
  components: {
    DialogQuizDate,
    DialogQuizStatus,
    TopquizTippy,
    HostQuizItemControls
  },
  data() {
    return {
      editingName: false,
      editingDate: false,
      editingStatus: false,
      newName: this.quiz.name
    };
  },
  computed: {
    quizStatusString() {
      return explanations.quiz_status_names[this.quiz.status];
    },
    quizVisibilityString() {
      return explanations.visibility_names[this.quiz.public];
    },
    explainVisibility() {
      return explanations.visibility[this.quiz.public];
    },
    explainCalendarVisibility() {
      return explanations.visibility_calendar[this.quiz.show_in_calendar];
    },
    quizDate() {
      if (this.quiz.event_time == 0) {
        return "no event time";
      }

      return this.$moment(this.quiz.event_time).format("YYYY-MM-DD HH:mm");
    },
    statusClass() {
      return "tq-status-" + this.quiz.status;
    }
  },
  methods: {
    changeVisibility() {
      this.$topquiz.sendCommand(
        "host_changeQuizVisibility",
        this.$topquiz.SessionKey,
        this.quiz.id,
        1 - this.quiz.public
      );
    },
    changeStatus() {
      this.editingStatus = true;
    },
    statusChanged(ev, status) {
      if (this.quiz.status == status) {
        return;
      }
      this.$topquiz.sendCommand(
        "host_changeQuizStatus",
        this.$topquiz.SessionKey,
        this.quiz.id,
        status
      );
    },
    changeDate() {
      this.editingDate = true;
    },
    dateChanged(ev, date) {
      if (this.quiz.event_time == date) {
        return;
      }

      if (date == 0) {
        this.changeCalendarVisibility();
      }

      this.$topquiz.sendCommand(
        "host_changeQuizDate",
        this.$topquiz.SessionKey,
        this.quiz.id,
        date
      );
    },
    changeName() {
      this.editingName = true;
      setTimeout(() => {
        this.$refs.nameInput.focus();
      }, 10);
    },
    nameChanged() {
      this.editingName = false;

      if (this.quiz.name == this.newName) {
        return;
      }
      this.$topquiz.sendCommand(
        "host_changeQuizName",
        this.$topquiz.SessionKey,
        this.quiz.id,
        this.newName
      );
    }
  },
  created() {
    this.$topquiz.on(this, "quizNameChanged", params => {
      if (params[0] == this.quiz.id) {
        this.quiz.name = params[1];
      }
    });
    this.$topquiz.on(this, "quizStatusChanged", params => {
      if (params[0] == this.quiz.id) {
        this.quiz.status = params[1];
      }
    });
    this.$topquiz.on(this, "quizVisibilityChanged", params => {
      if (params[0] == this.quiz.id) {
        this.quiz.public = params[1];
      }
    });
    this.$topquiz.on(this, "quizDateChanged", params => {
      if (params[0] == this.quiz.id) {
        this.quiz.event_time = params[1];
      }
    });
    this.$topquiz.on(this, "host_changeQuizDate_success", params => {
      if (params[0] == this.quiz.id) {
        this.$emit("host-changed-time", this.quiz.id);
      }
    });
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  }
};
</script>
